var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window',{attrs:{"touchless":"","value":_vm.slider}},_vm._l((_vm.categories),function(category){return _c('h-hint',{key:category.id,attrs:{"choice":category.isMultipleChoice,"min":_vm.MenuChoice.min(category),"max":_vm.MenuChoice.max(category)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }